module.exports = __webpack_public_path__ + "a48e00db17b304e20e61801290e90a09.svg";